var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"page-effect RegEvent-wrapper edu-rage event_list_reg ss-pre-ev-list"},[_c('section',{staticClass:"event-box-list-wrapper"},[_c('div',{staticClass:"container-fluid"},[_c('p',[_vm._v("helooooo")])])])])])
}]

export { render, staticRenderFns }